<template>
    <customer-layout>
        <div v-if="user.iprofile_token != null" class="flex flex-col items-center content-center justify-center h-screen bg-gray-800">
            <div class="p-4 mx-4 font-bold text-center text-white bg-red-500 rounded-md">

                <h3>{{ $t('ATTENTION') }}</h3><p>{{ $t('IF YOU UPLOAD ANOTHER QR CODE') }}<br>{{ $t('YOU WILL LOSE ALL OSM Coins') }}</p>
            </div>
            <div class="mx-4">
            <button
                @click="user.iprofile_token = null"
                class="w-full px-4 py-2 my-4 font-semibold text-center text-white bg-transparent border border-white rounded-full shadow"
            >
            {{ $t("I understand, let's proceed") }}
                    </button>
            <inertia-link 
                :href="route('dashboard')"
                class="block w-full px-4 py-2 mt-4 font-semibold text-center text-white bg-transparent border border-white rounded-full shadow"
            >
             {{ $t("back to home") }}
            </inertia-link>
            </div>

        </div>
        
        <div v-else class="flex flex-col items-center content-center justify-center h-screen bg-gray-800">

            <img src="/img/icon-qrcode.svg" alt="gem" class="w-4/12 my-2" />
            <h4 class="px-8 py-1 text-xl text-center text-white">{{ $t("You have not yet uploaded the I-Profile questionnaire") }}</h4>
            <inertia-link :href="route('qrcode.create')" class="px-6 py-2 mx-4 my-4 text-center text-white bg-pink-600 rounded-xl">{{$t('It begins now')}}</inertia-link>

            <h4 class="px-8 py-1 mt-4 text-center text-white">{{ $t("Don't have the I-Profile questionnaire?") }}</h4>
            <a href="https://docs.google.com/forms/d/1tliF3LoW4eCZn0rOZCMxxTcdnqMW8FCSZ8Sr977ymoQ/edit?ts=60c74cbe" target="blank" class="px-6 py-2 mx-4 my-4 text-center text-white bg-blue-600 rounded-xl">{{ $t('Request it') }}</a>
        </div>
    </customer-layout>
</template>


<script>
    import CustomerLayout from '@/Layouts/CustomerLayout'
    import QrReader from '@/Components/QrReader'
    
    export default {
        components: {
            CustomerLayout,
            QrReader,
        },
        props: ['user'],
    }
</script>